module.exports = __webpack_public_path__ + "07423e66a7f2090b85ca332e234da1ee.pdf";